export default __webpack_public_path__ + "static/media/banner6.21d44ac5.jpeg";